/* Open Shopify's native preferences only if automatic first-visit display is missing. */
(function () {
  'use strict';
  function start() {
    if (!window.Shopify || window.Shopify.designMode || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      var attempts = 0;
      function check() {
        var privacy = window.Shopify.customerPrivacy;
        if (!privacy || !privacy.shouldShowBanner()) return;
        var consent = privacy.currentVisitorConsent();
        if (['analytics', 'marketing', 'preferences'].some(function (purpose) {
          return consent[purpose] === 'yes' || consent[purpose] === 'no';
        })) return;
        var visibleConsentUi = Array.prototype.some.call(document.querySelectorAll(
          '[id^="shopify-pc__"][role="dialog"], [id^="shopify-pc__"][role="alertdialog"], #shopify-pc__banner, #shopify-pc__prefs'
        ), function (element) { return element.getClientRects().length > 0; });
        if (visibleConsentUi) return;
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences().catch(function (error) {
            console.warn('Midas Luxe: cookie preferences could not open.', error);
          });
          return;
        }
        attempts += 1;
        if (attempts < 10) window.setTimeout(check, 1000);
      }
      window.setTimeout(check, 2000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
